import * as types from 'manuals/actions/types'

export const ENDPOINT_MANUAL_URL = '/api/manuals/'
export const ENDPOINT_MANUAL_CATEGORY_URL = '/api/manuals/categories/'


export const setSearchText = (searchText) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TEXT,
        searchText: searchText
    })
}


